// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/modules/_is-array.js
// module id = 105
// module chunks = 0 1 2 3